import { Link } from "react-router-dom";
import styled from "styled-components";
import ToggleComponent from "../../../components/Toggle";

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #fff;
`;

export const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  margin-top: 32px;
`;

export const FormContainer = styled.form`
  label{
    text-transform: initial;
  }
`;

export const Title = styled.h1`
  font-size: 14px;
  font-weight: normal;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-bottom: 21px;
  padding-left: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.16);
  & > div {
    margin-left: 16px;
  }
`;

export const FieldsContainer = styled.div`
  margin-top: 16px;
`;

export const Horizontal = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  & > div {
    display: flex;
    flex: 1 0 100px;
    margin-left: 16px;
    @media (max-width: 768px) {
      margin-left: 0px;
      flex: 1 1 auto;
      width: 100%;
    }
  }

  & > div:first-child {
    margin-left: 0px;
  }
`;

export const FilterActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  flex-wrap: wrap;

  & > div:first-child {
    margin-left: 0px;
  }

  @media (max-width: 500px) {
    width: 100%;
  }

  & > div {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-left: 16px;
    @media (max-width: 500px) {
      margin-left: 0px;
    }
  }
`;

export const SubmitContainer = styled.div`
  width: 100%;
  max-width: 150px;

  @media (max-width: 500px) {
    margin-left: 0px;
    max-width: none;
    width: 100%;
  }
`;

export const TableTitleContainer = styled.div`
  padding: 16px 0px 16px 24px;
`;

export const TableTitle = styled.p``;

export const LinkButton = styled(Link)`
  text-decoration: none;
`;

export const GoBackContainer = styled.div``;

export const Toggle = styled(ToggleComponent)`
  justify-content: flex-start;
  margin-top: 16px;
  @media (max-width: 500px) {
    flex-direction: row;
  }
`;

export const DefaulterWarning = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 238px;

  p {
    margin-top: 8px;
    margin-bottom: 24px;
    font-family: "Inter";
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #020618;
  }

  .anticon.anticon-exclamation-circle {
    min-width: 80px;
    min-height: 80px;
  }

  svg {
    color: #002244;
    min-width: 80px;
    min-height: 80px;
  }

  div {
    margin-top: 0;
    flex-direction: column;
    gap: 8px;

    button {
      width: 100% !important;
    }
  }
`;

export const FormText = styled.p`
  margin-bottom: 0;
  font-family: "Inter";
  font-weight: ${({ sub }) => (sub ? 400 : 600)};
  font-size: ${({ sub }) => (sub ? "14px" : "16px")};
  line-height: 110%;
  letter-spacing: 0%;
`;

export const FormTextContainer = styled.div`
  margin-bottom: 8px;
`;
